import React from 'react';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <p>© {year} AI风格图片转换器 | 基于云雾AI</p>
    </footer>
  );
};

export default Footer; 